import React from 'react';
import AllRoute from '../router'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../sass/style.scss';
import { LanguageProvider } from '../../contexts/LanguageContext';


const App = () => { 

  return (
    <LanguageProvider>
      <div className="App" id='scrool'>
            <AllRoute/>
            <ToastContainer/>
      </div>
    </LanguageProvider>
  );
}

export default App;
